import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-284" data-mp="1ji3jpgma3sjo">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-285" data-mp="1te6qizs2sfcy" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-black text-lava" data-id="element-286" data-mp="1tgja1hdhexs4">:</span>}
          <span className="flex min-w-[68px] flex-col items-center rounded-xl bg-energy px-3 py-2.5 leading-none shadow-md shadow-black/40" data-id="element-287" data-mp="38tvt3f45zvme">
            <b className="font-display text-3xl font-bold tabular-nums text-carbon" data-id="element-288" data-mp="34vy2c7uqx1gw">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-carbon" data-id="element-289" data-mp="2h5p3x02xwiel">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}